import React, { useEffect, useState } from "react";
import { ReactComponent as Arrow } from "../../images/v-arrow.svg";
import { IMAGE_BASE_URL } from "../../helpers/constants";

const FlooringVoucherCard = ({ flooringVouchers }) => {
  const [activeIndex, setActiveIndex] = useState(
    flooringVouchers?.length > 0 ? flooringVouchers?.map((it) => it?.id) : [""]
  );

  //console.log("activeIndex", activeIndex);

  useEffect(() => {
    if (flooringVouchers?.length > 0) {
      setActiveIndex(flooringVouchers?.map((it) => it?.id));
    }
  }, [flooringVouchers]);

  const toggleSection = (id) => {
    setActiveIndex((prevIndices) => {
      if (prevIndices?.includes(id)) {
        const newIndices = prevIndices?.filter((it) => it !== id);
        return newIndices;
      } else {
        return [...prevIndices].concat(id);
      }
    });
  };
  const GetRedemptionCount = (max, redemedqty) => {
    const temp = max - redemedqty;
    if (temp > 0) {
      return temp;
    } else {
      return 0;
    }
  };

  return (
    <section className="flooring-full-card-section">
      {flooringVouchers &&
        flooringVouchers.map((item, index) => (
          <div className="flooring-full-card" key={index}>
            <div className="full-card-header">
              <div className="logo-block">
                <img
                  src={`${IMAGE_BASE_URL}/${item?.icon}`}
                  alt=""
                />
              </div>
              <div className="card-header-group">
                <div className="card-header-block">
                  <div className="header-block-list">
                    <h2>
                      {item.name === "BODYONLY" ? "BODY ONLY" : item?.name}
                    </h2>
                    <div className="inline-flex">
                      {item?.hasPremium ? (
                        <span className="category-list">
                          <img
                            src="/images/star.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Premium</span>
                        </span>
                      ) : null}
                      {item.featured ? (
                        <span className="category-list">
                          <img
                            src="/images/star.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Featured</span>
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="header-block-list">
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_clock.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Approval Time:{" "}
                      <strong className="ml-[5px] font-[600]">
                        {item?.approvalTime}
                      </strong>
                    </p>
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_zap.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Loan to Value:
                      <strong className="ml-[5px] font-[600]">
                        {item?.ltv}
                      </strong>
                    </p>
                  </div>
                </div>
                <div className="card-header-info">
                  <div className="info-header-block-list">
                    <h3>
                      Contact No: <span>{item.phoneNumber}</span>
                    </h3>
                    <h4>
                      Email: <span>{item.email}</span>
                    </h4>
                  </div>
                  <div className="info-header-block-list">
                    <h3>
                      Address:{" "}
                      <span>
                        {item.addressLine1}, {item?.addressLine2}{" "}
                        {item?.postalCode}
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="eligible-btn">
              <button
                className="btn"
                type="button"
                onClick={() => toggleSection(item?.id)}
              >
                Eligible Vouchers ({item?.vouchers.length})
                <span
                  className={`${activeIndex?.includes(item?.id) ? null : "down-arrow"
                    }`}
                >
                  <Arrow />
                </span>
              </button>
            </div>
            {activeIndex?.includes(item?.id) ? (
              <div className="eligible-voucher-section">
                {item.vouchers &&
                  item.vouchers?.length > 0 &&
                  item.vouchers.map((eligibleVouchers, idx) => (
                    <div className="eligible-voucher-block">
                      <div className="eligible-circle-left" />
                      <div className="eligible-voucher-list">
                        <h1>{eligibleVouchers.name}</h1>
                        <h2>
                          Interest Rate{" "}
                          <span>
                            {eligibleVouchers?.interest_rate.slice(
                              0,
                              eligibleVouchers?.interest_rate.indexOf(".") + 2
                            )}
                            %
                          </span>
                        </h2>
                        <h2>
                          {eligibleVouchers?.customer_type?.label}{" "}
                          {eligibleVouchers?.voucher_qty_type?.value == 0 ? (
                            <span>
                              {eligibleVouchers?.voucher_qty_type?.label}
                            </span>
                          ) : (
                            <span>{`${GetRedemptionCount(
                              eligibleVouchers?.redeemed_qty,
                              eligibleVouchers?.qty
                            )} / ${eligibleVouchers?.qty
                              } voucher(s) left`}</span>
                          )}
                        </h2>
                        <h3>
                          Valid From{" "}
                          <span>
                            {eligibleVouchers.start_period}-
                            {eligibleVouchers?.end_period === "" ||
                              eligibleVouchers?.end_period === null ||
                              eligibleVouchers?.end_period === undefined
                              ? "Furthe Notice"
                              : ""}
                          </span>
                        </h3>
                        <h3>
                          Eligible Floor Amount{" "}
                          <span>
                            ${eligibleVouchers.amount_from}-$
                            {eligibleVouchers.amount_to}
                          </span>
                        </h3>
                        <h4>
                          You Redeemed{" "}
                          <span>
                            {eligibleVouchers.dealer_redeemed} / {eligibleVouchers?.max_redemption} times
                          </span>
                        </h4>
                      </div>
                      <div className="eligible-circle-right" />
                    </div>
                  ))}
              </div>
            ) : null}
          </div>
        ))}
    </section>
  );
};

export default FlooringVoucherCard;
